(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cta-blog-posts"] && !window.DesignMode) return;
  try {
    
$.ajax({
  url: "https://blog.breathingcolor.com/wp-json/wp/v2/posts/?per_page=3&_embed=1",
  type: "GET",
  success: function (result) {
    $(result).each(function () {
      var categories = this._embedded['wp:term'];
      var category = '';
      if (categories.length>0) {
        console.log(categories[0][0]);
        category = categories[0][0].name;
      }

      var postObject = {
        title: this.title.rendered,
        link: this.link,
        image: this.featured_image_src,
        category: category
      };


      var postTemplate = '<div class="col-sm-4 col-md-4 col-lg-4">\n' +
        '                            <div class="col-section col-height pl-0 pr-0">\n' +
          '                                <img src="'+postObject.image+'" width="100%" alt=""/>\n' +
          '                                <div class="pl-1 pr-1 pb-1 pt-1 ">\n' +
            '                                    <p class="bt ">' + postObject.title.toLowerCase() + '</p>\n' +
            '                                    <p class="tag">'+postObject.category+'</p>\n' +
            '                                    <a href="' + postObject.link + '" class="btn rounded">Read Article</a>\n' +
            '                                </div>\n' +
          '                            </div>\n' +
        '                        </div>';
      $('#bcLatestPosts').append(postTemplate);
    });
  },
  error: function (xhr) {
  console.log(xhr.responseText);
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-fixed"]) return;
  try {
    
  function initPromoFixed(){
    var $ttpromofixed = $(".tt-promo-fixed"),
    	$promofixeddata = $(".promofixeddata"),
        $promofixedclose = $ttpromofixed.find(".tt-btn-close");
    
    if($('html').hasClass('touch-device') && $ttpromofixed.hasClass('hidden-mobile')) return false;
    if($promofixeddata.length == 0) return false;
    
    setPromoFixedItem($ttpromofixed, $promofixeddata);
	showPromoFixed($ttpromofixed, $ttpromofixed.data('start'));
    
	showPromoFixedNextMessage($ttpromofixed, $promofixeddata, $promofixedclose)

    $promofixedclose.click(function(){
      $ttpromofixed.fadeTo(100, 0);
    });
  }
  function showPromoFixedNextMessage($modal, $data, $close){
    var nextmin = $modal.data('min'),
        nextmax = $modal.data('max');
	var i = getRndInteger(nextmin, nextmax);
    setTimeout(function(){
      $close.trigger('click');
      setTimeout(function(){
        setPromoFixedItem($modal, $data);
        showPromoFixed($modal, 0);
        showPromoFixedNextMessage($modal, $data, $close);
      }, 100);
    }, i);
  }
  function getPromoFixedCustomProductIndex($promofixeddata){
    var min = 0,
        max = $promofixeddata.children().length-1;
    return getRndInteger(min, max);
  }
  function setPromoFixedItem($modal, $data){
    var i = getPromoFixedCustomProductIndex($data)
    var data = $data.children().eq(i);
    $modal.find('.tt-img').find('a').attr('href', data.data('url')).find('img').attr('src', data.data('image')).attr('alt', data.data('alt'));
    $modal.find('.pr_name').attr('href', data.data('url')).text(data.data('name'));
    
    var nummin = parseInt(data.data('min')),
    	nummax = parseInt(data.data('max')),
    	num = getRndInteger(nummin, nummax);
    $modal.find('.tt-info-value').text(num);

    if (typeof data.data('text') != 'undefined') {
        var str = data.data('text').split('||'),
    	    i = getRndInteger(0, str.length-1);
    	$modal.find('.tt-info-text').text(str[i]);
    }
  }
  function showPromoFixed($parent, delay){
    setTimeout(function(){
      $parent.fadeTo(300, 1);
    }, delay);
  }
  function getRndInteger(min, max) {
    return Math.floor(Math.random() * (max - min) ) + min;
  }
  setTimeout(initPromoFixed, 300);

  } catch(e) { console.error(e); }
})();
})();
